import React from 'react'
import styled from 'styled-components'
import { PageType } from '../interfaces/types'
import MenuItem from './MenuItem'
import MenuItemWithIcon from './MenuItemWithIcon'
import Profile from './Profile'

const StyledDiv = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  width: 300px;
  background-color: #0548CB;
  z-index: 1000;
  padding: 10px;
`

const Sidebar = (
  props: {
    setCurrentPage: (page: PageType, path?: string) => void,
  }
) => {
  return (
    <StyledDiv
      onClick={(e) => {
        // e.preventDefault()
        e.stopPropagation()
      }}
    >
      {/* <Profile /> */}
      <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        margin: '2em 0',
      }}>
        <MenuItem id='DEFAULT' content="이대호의 프로필" onClick={() => { window.location.href = "https://daeho.oopy.io/"}}></MenuItem>
        <MenuItem id='SURVEY' content="설문조사" onClick={() => { props.setCurrentPage('SURVEY')}}></MenuItem>
        <MenuItem id='RESULT' content="시민들의 목소리" onClick={() => { props.setCurrentPage('RESULT')}}></MenuItem>
        <MenuItem id='MANIFESTOLIST' content="공약 리스트" onClick={() => { props.setCurrentPage('MANIFESTOLIST')}}></MenuItem>
      </div>
      <div
        style={{
          fontWeight: 700,
          color: 'rgba(252, 252, 252, 0.5)',
          marginBottom: '1em',
        }}
      >
        이대호 더 알아보기
      </div>
      <div>
        <MenuItemWithIcon content="인스타그램" href="https://www.instagram.com/daeho.io/"></MenuItemWithIcon>
        <MenuItemWithIcon content="블로그" href="https://www.daeho.io/"></MenuItemWithIcon>
        <MenuItemWithIcon content="페이스북" href="https://www.facebook.com/imdaeho2"></MenuItemWithIcon>
        <MenuItemWithIcon content="트위터" href="https://twitter.com/daecrong"></MenuItemWithIcon>
      </div>
    </StyledDiv>
  )
}

export default Sidebar